module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO11Retroalimentacion (ant42).82b3af8.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO11Retroalimentacion (ant42).mp4
// module id = 737
// module chunks = 1